import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import config from './Config/Env';
import { createTranslationTagProcessorPlugin } from './Services/TranslationTagProcessor';

const isDevelopment = APP_ENVIRONMENT === 'local';

const tagProcessorPlugin = createTranslationTagProcessorPlugin({
    contentPreservingTags: config.TAG_PROCESSOR.CONTENT_PRESERVING_TAGS,
    contentRemovingTags: config.TAG_PROCESSOR.CONTENT_REMOVING_TAGS,
    enableLogging: config.TAG_PROCESSOR.ENABLE_LOGGING,
});

const i18nInstance = i18n.use(ChainedBackend).use(LanguageDetector).use(initReactI18next);

if (config.TAG_PROCESSOR.ENABLED) {
    i18nInstance.use(tagProcessorPlugin);
}

i18nInstance.init({
    supportedLngs: config.AVAILABLE_LANGUAGES,
    fallbackLng: config.DEFAULT_LANGUAGE,
    ns: config.PRELOAD_NAMESPACES,
    defaultNS: config.DEFAULT_NAMESPACE,
    debug: isDevelopment,

    backend: {
        backends: [LocalStorageBackend, HttpBackend],
        backendOptions: [
            {
                // LocalStorage options for static translations
                prefix: config.CACHES.STATIC.PREFIX,
                expirationTime: config.CACHES.STATIC.EXPIRATION_TIME,
                defaultVersion: config.CACHES.VERSION,
            },
            {
                // HTTP options for static files
                loadPath: config.BUILT_TRANSLATION_FILES.PATH,
                requestOptions: config.BUILT_TRANSLATION_FILES.REQUEST_OPTIONS,
            },
        ],
    },

    saveMissing: isDevelopment,
    saveMissingTo: 'all',
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
        if (isDevelopment) {
            // eslint-disable-next-line no-console
            console.warn('🌎 i18next --- missingKeyHandler');
            // eslint-disable-next-line no-console
            console.group(`Missing translation: ${lng}/(${ns}:${key})`);
            // eslint-disable-next-line no-console
            console.log('Missing translation');
            // eslint-disable-next-line no-console
            console.log('fallbackValue', fallbackValue);
            // eslint-disable-next-line no-console
            console.log('lng', lng);
            // eslint-disable-next-line no-console
            console.log('ns', ns);
            // eslint-disable-next-line no-console
            console.log('key', key);
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
    },

    detection: {
        order: config.DETECTION.ORDER,
        lookupQuerystring: config.DETECTION.LOOKUP_QUERYSTRING,
        lookupCookie: config.DETECTION.LOOKUP_COOKIE,
        lookupLocalStorage: config.DETECTION.LOOKUP_LOCAL_STORAGE,
        caches: config.DETECTION.CACHES,
        cookieOptions: config.DETECTION.COOKIE_OPTIONS,
    },

    interpolation: {
        escapeValue: false,
    },

    react: {
        useSuspense: true,
    },

    postProcess: config.TAG_PROCESSOR.ENABLED ? ['translationTagProcessor'] : undefined,
});

export default i18n;
